/**
 * The pre-filled contents of the definition box.
 *
 * Indented because the box is a plain textarea: one long line is valid JSON and
 * unusable to edit. Answers empty text for a definition that never arrived, so a
 * caller can tell an absent pre-fill from a small one — a served definition
 * always serializes to something.
 */
export const formatStarterTemplate = (formTemplate: unknown): string =>
  formTemplate === undefined ? '' : JSON.stringify(formTemplate, null, 2)
